/**
 * AdvancedFiltersPanel — Collapsible advanced filter controls for the contact table.
 *
 * @param {Object} props
 * @param {boolean}  props.isOpen - Whether the panel is visible
 * @param {Object}   props.filters - Current filter values { city, has_email, has_website, has_instagram, bounce_reduction, range_field, range_min, range_max }
 * @param {Function} props.onChange - (event) => void — handles input/select changes (uses e.target.name)
 * @param {Function} props.onReset - () => void — resets all filters to defaults
 */
import React from "react";

const BOOLEAN_OPTIONS = [
  { value: 'any', label: 'Any' },
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' },
];

const RANGE_FIELDS = [
  { value: 'lead_rating', label: 'Rating' },
  { value: 'lead_reviews', label: 'Reviews' },
  { value: 'lead_instagram_followers', label: 'Followers' },
  { value: 'lead_stars', label: 'Stars' },
];

const BOUNCE_REDUCTION_OPTIONS = [
  { value: 'any', label: 'Any' },
  { value: 'triggered', label: 'Triggered (any)' },
  { value: 'reroute', label: 'Rerouted to standard mailbox' },
  { value: 'parked', label: 'Parked / not sent' },
];

const BooleanFilter = ({ label, name, value, onChange }) => (
  <div className="filter-group">
    <label>{label}</label>
    <select name={name} value={value} onChange={onChange}>
      {BOOLEAN_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  </div>
);

const AdvancedFiltersPanel = ({ isOpen, filters, onChange, onReset }) => {
  if (!isOpen) return null;

  return (
    <div className="advanced-filters-panel">
      <div className="filter-group">
        <label>City</label>
        <input type="text" name="city" value={filters.city} onChange={onChange} placeholder="e.g. Berlin" />
      </div>
      <BooleanFilter label="Has Email" name="has_email" value={filters.has_email} onChange={onChange} />
      <BooleanFilter label="Has Website" name="has_website" value={filters.has_website} onChange={onChange} />
      <BooleanFilter label="Has Instagram" name="has_instagram" value={filters.has_instagram} onChange={onChange} />
      <div className="filter-group">
        <label>Bounce Reduction</label>
        <select name="bounce_reduction" value={filters.bounce_reduction ?? 'any'} onChange={onChange}>
          {BOUNCE_REDUCTION_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      </div>
      <div className="filter-group range-filter">
        <label>Range Filter</label>
        <select name="range_field" value={filters.range_field} onChange={onChange}>
          {RANGE_FIELDS.map(f => <option key={f.value} value={f.value}>{f.label}</option>)}
        </select>
        <input type="number" name="range_min" value={filters.range_min} onChange={onChange} placeholder="Min" />
        <input type="number" name="range_max" value={filters.range_max} onChange={onChange} placeholder="Max" />
      </div>
      <div className="filter-group actions">
        <button onClick={onReset}>Reset Filters</button>
      </div>
    </div>
  );
};

export default AdvancedFiltersPanel;
